<section class="page-stack">
  @if (error) {
    <div class="alert alert-danger">{{ error }}</div>
  }

  <div class="dashboard-grid">
    <div class="metric-card cyan">
      <span>Active Employers</span>
      <strong>{{ summary?.active_employers || 0 }}</strong>
      <small>{{ summary?.employers_total || 0 }} employers total</small>
    </div>

    <div class="metric-card">
      <span>Employers</span>
      <strong>{{ summary?.employers_total || 0 }}</strong>
      <small>Registered companies</small>
    </div>

    <div class="metric-card green">
      <span>Active Loans</span>
      <strong>{{ money(summary?.active_loans?.amount_cents) }}</strong>
      <small>{{ summary?.active_loans?.count || 0 }} loans currently being serviced</small>
    </div>

    <div class="metric-card yellow">
      <span>Pending Loans</span>
      <strong>{{ money(summary?.pending_loans?.amount_cents) }}</strong>
      <small>{{ summary?.pending_loans?.count || 0 }} loans awaiting completion</small>
    </div>

    <div class="metric-card cyan">
      <span>Active Users</span>
      <strong>{{ summary?.active_users || 0 }}</strong>
      <small>Accounts with active status</small>
    </div>

    <div class="metric-card pink">
      <span>Users With Active Investment</span>
      <strong>{{ summary?.users_with_active_investment || 0 }}</strong>
      <small>Users with money lent out</small>
    </div>

    <div class="metric-card green">
      <span>Active Investment</span>
      <strong>{{ money(summary?.active_investment_cents) }}</strong>
      <small>Active user money lent</small>
    </div>

    <div class="metric-card pink">
      <span>Capital Hub Liability</span>
      <strong>{{ money(summary?.capital_hub_liability_cents) }}</strong>
      <small>Early withdrawals before loan terms end</small>
    </div>

    <div class="metric-card yellow">
      <span>Admin Fund Pool</span>
      <strong>{{ money(summary?.admin_fund_pool_balance_cents) }}</strong>
      <small>Fallback funds available for disbursement shortfalls</small>
    </div>

    <div class="metric-card cyan">
      <span>Income After Repayment</span>
      <strong>{{ money(summary?.income_after_repayment_cents) }}</strong>
      <small>Rolling repayment income</small>
    </div>

    <div class="metric-card danger">
      <span>Overdue Payments</span>
      <strong>{{ money(summary?.overdue_payments?.amount_cents) }}</strong>
      <small>{{ summary?.overdue_payments?.count || 0 }} overdue loans</small>
    </div>
  </div>

  @if (loading) {
    <div class="panel p-3 text-muted-soft">Loading live dashboard...</div>
  }
</section>
